/**
 * MCP Tools Registration
 *
 * Tools allow AI models to query the design system.
 */

import { McpServer } from '@modelcontextprotocol/sdk/server/mcp.js';
import { registerSearchComponentsTool } from './searchComponents.js';
import { registerGetComponentPropsTool } from './getComponentProps.js';
import { registerSuggestPatternTool } from './suggestPattern.js';
import { registerValidateUsageTool } from './validateUsage.js';

/**
 * Register all tools with the MCP server
 */
export function registerTools(server: McpServer): void {
  registerSearchComponentsTool(server);
  registerGetComponentPropsTool(server);
  registerSuggestPatternTool(server);
  registerValidateUsageTool(server);
}
